import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';
import {
    AbregelbareLeistungLowerEqualsInstallierteValidatorDirective,
} from './abregelbare-leistung-lower-equals-installierte-validator.directive';

/**
 * If the abregelbareLeistungKW has an error set, but the installierteLeistungKW gets changed in a manner,
 * that the error becomes invalid, this directive resets the error in the abregelbareLeistungKW FormControl
 *
 * Checks that the "Abregelbare Leistung KW" is not greater than the "installierte Leistung KW"
 */
@Directive(
    {
        selector: '[tnbResetAbregelbareLeistungErrorWhenInstallierteChanged]',
        providers: [
            {
                provide: NG_VALIDATORS,
                useExisting: ResetAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class ResetAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective implements Validator {

    @Input() tnbResetAbregelbareLeistungErrorWhenInstallierteChanged: NgModel;

    validate(installierteLeistungControl: AbstractControl): ValidationErrors | null {

        const abregelbareLeistungNgModel = this.tnbResetAbregelbareLeistungErrorWhenInstallierteChanged;

        if (installierteLeistungControl.value !== null && typeof installierteLeistungControl.value !== 'undefined') {
            const key = AbregelbareLeistungLowerEqualsInstallierteValidatorDirective.ERROR_KEY;
            if (abregelbareLeistungNgModel.value !== null && typeof abregelbareLeistungNgModel.value !== 'undefined') {
                if (parseFloat(installierteLeistungControl.value) >= parseFloat(abregelbareLeistungNgModel.value)) {
                    if (abregelbareLeistungNgModel.errors !== null) {
                        delete abregelbareLeistungNgModel.errors[key];
                        abregelbareLeistungNgModel.control.setErrors(null);
                        abregelbareLeistungNgModel.control.markAsTouched();
                    }
                } else {
                    const obj = { [key]: true };
                    abregelbareLeistungNgModel.control.setErrors(obj);
                    abregelbareLeistungNgModel.control.markAsTouched();
                }
            }
        }
        return null;
    }

}
